import React, { Component } from "react";
import "./Navbar.scss";
import { clearTranslate } from "./gtUtils";
// import Settings from "./Settings";
import { Popup } from "semantic-ui-react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
// import ResearchIcon from "../../assets/svg/researchWhite.svg";
// import collectionIcon from "../../assets/svg/collectionWhite.svg";
// import dashboardIcon from "../../assets/svg/dashboardWhite.svg";
import InteractiveIcon from "../../assets/svg/interactive-help-icon.svg";
import InteractiveIconBlue from "../../assets/svg/interactive-help-icon-blue.svg";
import { UpdateUserDetails } from "../../actions/globalAction";

import GoogleTranslateComponent from "./GoogleTranslateComponent/GoogleTranslateComponent";
import ProfileIconComponent from "./ProfileIconComponent";
import NotificationModal from "./NotificationModal";

// Menu Icons
// import { ReactComponent as AlertIcon } from "../../assets/svg/alert.svg";
// import { ReactComponent as ProfileIcon } from "../../assets/svg/profileIcon.svg";
// import { ReactComponent as CollectionIcon } from "../../assets/svg/collection.svg";
// import { ReactComponent as DashboardIcon } from "../../assets/svg/dashboard.svg";
// import { ReactComponent as DatausageIcon } from "../../assets/svg/datausage.svg";
// import { ReactComponent as OwnedpageanalyticsIcon } from "../../assets/svg/facebook-insight.svg";
// import { ReactComponent as QueryIcon } from "../../assets/svg/query.svg";
// import { ReactComponent as ReportIcon } from "../../assets/svg/report.svg";
// import { ReactComponent as SocialtokensIcon } from "../../assets/svg/socialtokens.svg";
// import { ReactComponent as TrendIcon } from "../../assets/svg/trend.svg";
// import { ReactComponent as UsermanagementIcon } from "../../assets/svg/usermanagement.svg";
// import { ReactComponent as NotificationIcon } from "../../assets/svg/notificationIicon.svg";
// import { ReactComponent as DownloadsIcon } from "../../assets/svg/downloads.svg";
import { ReactComponent as PageInfoIcon } from "../../assets/svg/info.svg";
import { ReactComponent as FreePackageIcon } from "./free.svg";
import { ReactComponent as StarterPackageIcon } from "./starter.svg";
import { ReactComponent as SmbPackageIcon } from "./smb.svg";
import CompanyLogo from "../../assets/radarr-logo.png";
import moment from "moment-timezone";
import UpgradeButton from "../AppContainer/UpgradeToPremium/UpgradeButton";
// import Tour from "../MainContent/Tour";

class Navbar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            notificationModalOpen: false,
        };
    }

    updatePageTitle = () => {
        document.title = this.props.pageTitle ? `${this.props.pageTitle} | Radarr` : "Radarr";
    };

    componentDidMount() {
        this.updatePageTitle();
    }

    componentDidUpdate(prevProps, prevstate) {
        this.updatePageTitle();

        if (prevProps.googleTranslate !== this.props.googleTranslate && !this.props.googleTranslate) clearTranslate();
    }

    fullName = (name) => {
        return <div className="full-name">{name.join("")}</div>;
    };

    truncatedName = (text) => {
        let name = text;
        if (name.length > 40) {
            name = name.join("").substring(0, 40 - 3) + "...";
            //    return name;
            return <Popup inverted trigger={<span className="full-name-popup">{name}</span>} content={() => this.fullName(text)} position="bottom center" />;
        } else {
            return text.join("");
        }
    };

    getPackageName = () => {
        // if (!this.props.packageObj?.subscription?.trial_end) return;
        let icon;
        let packageName;
        if (this.props.packageObj.package_code === "free") {
            icon = <FreePackageIcon />;
            packageName = "You are on free package. Click here to upgrade.";
        } else if (this.props.packageObj.package_code === "starter") {
            icon = <StarterPackageIcon />;
            packageName = "Starter Package";
        } else if (this.props.packageObj.package_code === "smb") {
            icon = <SmbPackageIcon />;
            packageName = "Professional Package";
        }
        if (
            this.props.packageObj?.subscription?.trial_end &&
            this.props.packageObj.package_code !== "free" &&
            this.props.packageObj.subscription.status === "trialing"
        ) {
            let daysRemaining = moment(this.props.packageObj.subscription.trial_end).diff(moment(), "days", true);
            packageName += " - " + daysRemaining.toFixed(0) + " days trial remaining";
        }

        return <Popup content={packageName} className="navbar__package__icon" trigger={icon} size="tiny" inverted position="bottom center" />;
    };

    getTrialMessage = () => {
        if (
            this.props.packageObj?.subscription?.trial_end &&
            this.props.packageObj.package_code !== "free" &&
            this.props.packageObj.subscription.status === "trialing"
        ) {
            let daysRemaining = moment(this.props.packageObj.subscription.trial_end).diff(moment(), "days", true);
            return (
                <div className="trial-message">
                    {`You have ${daysRemaining.toFixed(0)} days of trial left. `}
                    <Link to="/gettingStarted">Get Started</Link>
                </div>
            );
        } else return null;
    };

    handleTour = () => {
        let switchInteractiveHelp = this.props.interactive_help_enabled == 1 ? 0 : 1;
        this.props.UpdateUserDetails(
            {
                interactive_help_enabled: switchInteractiveHelp,
            },
            "navbar",
        );
    };

    handleNotificationModal = () => {
        this.setState({ notificationModalOpen: !this.state.notificationModalOpen });
    };

    render() {
        let { notificationCounter } = this.props;
        let interactive_help_enabled = this.props.interactive_help_enabled;
        let navbarLogo = this.props?.agencyLogo ? this.props?.agencyLogo : CompanyLogo;
        return (
            <>
                <div className={`navbar skiptranslate `}>
                    <div className="navbar-items-left">
                        <div className="ttlogo">
                            {this.props.company.is_profile_setup === 0 ? (
                                <img className="companyLogo" src={CompanyLogo} />
                            ) : (
                                <Link to="/home">
                                    <img className="companyLogo" src={navbarLogo} />
                                </Link>
                            )}
                        </div>
                        {this.props.pageInfoText && (
                            <Popup
                                className="post-info-popup"
                                trigger={<PageInfoIcon className="post-info-icon" />}
                                content={this.props.pageInfoText}
                                position="bottom left"
                                size="mini"
                                on={["click"]}
                            />
                        )}
                    </div>
                    {this.props.packageObj && !this.props.packageObj.package_code.includes("enterprise") && this.getTrialMessage()}
                    {
                        // need to change this 0->1
                    }
                    {this.props.company.is_profile_setup === 1 && (
                        <div className="navbar-items-right">
                            {this.props.packageObj.package_code.includes("free") && <UpgradeButton className="upgrade__button" />}
                            {!this.props.packageObj.package_code.includes("enterprise") && !this.props.packageObj.package_code.includes("free") && (
                                <Link className="company_package" to="/billing/plans">
                                    {this.props.packageObj && this.getPackageName()}
                                </Link>
                            )}
                            <Link className="company_name" to="/profile">
                                {this.props.companyName && this.truncatedName(this.props.companyName.split(""))}
                            </Link>
                            {this.props.createDashboard && this.props.createDashboard()}
                            {/* {this.props.pageTitle === "Notification" ? <Settings /> : null} */}
                            {this.props.googleTranslate && <GoogleTranslateComponent />}
                            {
                                // !this.props.location.includes("/social-tokens") &&
                                // !this.props.location.includes("/owned-page") &&
                                !this.props.location.includes("/support") &&
                                    !this.props.location.includes("/settings/image-analytics") &&
                                    !this.props.location.includes("/gettingStarted") &&
                                    !this.props.location.includes("/billing") &&
                                    !this.props.location.includes("/tutorials") && (
                                        <div className="tour_toggle home_step0">
                                            <Popup
                                                trigger={
                                                    <img
                                                        src={interactive_help_enabled == 1 ? InteractiveIconBlue : InteractiveIcon}
                                                        className="tour-start items-center tour-link"
                                                        color="blue"
                                                        onClick={this.handleTour}
                                                    />
                                                }
                                                inverted
                                                size="mini"
                                                content={interactive_help_enabled == 0 ? "Enable Interactive Help" : "Disable Interactive Help"}
                                                position="bottom center"
                                                className="skiptranslate"
                                            />

                                            {!this.props.showGetStarted && interactive_help_enabled == 1 && this.props.tourComponent && (
                                                <this.props.tourComponent />
                                            )}
                                        </div>
                                    )
                            }
                            {/* {!(this.props.user?.roles.length === 1 && this.props.user?.roles.includes("token_provider")) &&
                                (this.state.notificationModalOpen ? (
                                    <Link to="/notification">
                                        <div className={`${notificationCounter && notificationCounter.total ? "notif-wrapper" : ""}`}>
                                            <span className="material-icons notification_step1">notifications</span>
                                            {notificationCounter && notificationCounter.total ? (
                                                <div className="notif-counter">
                                                    <p className="counter-text">{notificationCounter.total}</p>
                                                </div>
                                            ) : null}
                                        </div>
                                    </Link>
                                ) : (
                                    <div className="notification-modal">
                                        <span className="material-icons notification_step1">notifications</span>
                                        {notificationCounter && notificationCounter.total ? (
                                            <div className="notif-counter">
                                                <p className="counter-text">{notificationCounter.total}</p>
                                            </div>
                                        ) : null}
                                    </div>
                                ))} */}

                            <NotificationModal
                                notificationCounter={notificationCounter}
                                history={this.props.history}
                                isOpen={!(this.props.user?.roles.length === 1 && this.props.user?.roles.includes("token_provider"))}
                            />
                            <Link to="/support">
                                <Popup
                                    trigger={
                                        <span className="material-icons home_step3" style={{ marginLeft: "2px" }}>
                                            contact_support
                                        </span>
                                    }
                                    inverted
                                    size="mini"
                                    content="Help & Support"
                                    position="bottom center"
                                />
                            </Link>

                            <ProfileIconComponent
                                profilePic={this.props.profilePic}
                                companyPic={this.props.companyPic}
                                userName={this.props.userName}
                                companyName={this.props.companyName}
                            />
                        </div>
                    )}
                </div>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        packageObj: state.globalReducer.packageObj,
        profilePic: state.globalReducer.profilePic,
        notificationCounter: state.globalReducer.notificationCounter,
        companyPic: state.globalReducer.company && state.globalReducer.company.company_logo_v2,
        userName: state.globalReducer.company && state.globalReducer.company.user_name,
        companyName: state.globalReducer.company && state.globalReducer.company.company_name,
        agencyLogo: state.globalReducer.company?.whitelabel_logo,
        interactive_help_enabled: state.globalReducer.interactive_help_enabled,
        showGetStarted: state.globalReducer.showGetStarted,
        user: state.globalReducer.user,
        company: state.globalReducer.company,
    };
}

const mapDispatchToProps = (dispatch) => ({
    UpdateUserDetails: (data, position) => dispatch(UpdateUserDetails(data, position)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
